import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  CardContent,
  Divider,
  Chip,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useGetUserInfoOnyQuery,
  useGetCategoryQuery,
  useGetbyStoreCatgoryItmeQuery,
  useDeleteMainItemMutation,
  useGetProductWithStoreQuery,
  useGetStoreQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IVariantViewUp,
  IStore,
  IUserAdmin,
  IStoreItemView,
} from "../../../Api/Interface/api.interface";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopupTenant from "../Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { IoIosImages } from "react-icons/io";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import Pagination from "../../../Components/Pagination";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import dayjs, { Dayjs } from "dayjs";
import ReplaceImage from "../../../Images/repImg.png";

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const [selectedIsActive, setSelectedIsActive] = useState<number | null>(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectCustomer, setSelectCustomer] = useState<IStore | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [openDeleteProductMI, setOpenDeleteProductMI] = useState(false);
  const [productToDeleteMI, setProductToDeleteMI] = useState<IStore | null>(
    null
  );
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetStoreQuery({
    searchText: "",
    id: String(ProductId),
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    isError: productIsError,
    refetch,
  } = useGetbyStoreCatgoryItmeQuery({
    storeId: String(ProductId),
    searchText: searchQuery,
  });

  const { data: productCountData, isLoading: productCountIsLoading } =
    useGetProductWithStoreQuery({
      searchText: "",
      id: null,
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
      mainItemId: null,
    });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IStore;
    }
    return null;
  }, [data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productList = useMemo(() => {
    return productCountData?.data as IVariantViewUp[];
  }, [productCountData?.data]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);

  const variantMap = useMemo(() => {
    const map = new Map<
      string,
      {
        name: string;
        displayname: string;
        variantImg: string;
        variantRefNumber: string;
        categoryName: string | null;
      }
    >();

    productList?.forEach((teamMember) => {
      const categoryName = categoryMap.get(teamMember.categoryId) || null;

      map.set(teamMember.id, {
        name: teamMember.variantName,
        variantRefNumber: teamMember.variantRefNumber,
        variantImg: teamMember.variantImg,

        displayname: teamMember.variantDisplayName,
        categoryName,
      });
    });

    return map;
  }, [productList, categoryMap]);

  const storeMap = useMemo(() => {
    const map = new Map<
      string,
      {
        name: string;
        displayname: string;
        variantImg: string;
        variantRefNumber: string;
        categoryName: string | null;
      }
    >();

    productList?.forEach((teamMember) => {
      const categoryName = categoryMap.get(teamMember.categoryId) || null;

      map.set(teamMember.id, {
        name: teamMember.variantName,
        variantRefNumber: teamMember.variantRefNumber,
        variantImg: teamMember.variantImg,

        displayname: teamMember.variantDisplayName,
        categoryName,
      });
    });

    return map;
  }, [productList, categoryMap]);

  const handleOpenEditTenant = () => {
    setSelectCustomer(product);
    setOpenDialog(true);
  };

  const handleCloseEditTenant = () => {
    setSelectCustomer(null);
    setOpenDialog(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleCloseDeletePopupMI = () => {
    setProductToDeleteMI(null);
    setOpenDeleteProductMI(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const [deleteCategoryMI] = useDeleteMainItemMutation();
  const handleDeleteMI = async (id: string) => {
    try {
      const response = await deleteCategoryMI(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProductMI(false);
        navigate(`/store/list`);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Product");
    }
  };

  const coursings: IStoreItemView[] = Array.isArray(productData?.data)
    ? (productData?.data as IStoreItemView[])
    : [];

  const countVariant: IVariantViewUp[] = Array.isArray(productData?.data)
    ? (productData?.data as IVariantViewUp[])
    : [];

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const CompactStatusCard = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? CheckCircleIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  const CompactStatusCardIcon = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? ProductionQuantityLimitsOutlinedIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  type DetailRowProps = {
    label: string;
    value: React.ReactNode;
  };
  const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => (
    <Typography
      variant="subtitle1"
      sx={{
        display: "flex",
        borderBottom: "1px solid #e0e0e0",
        py: 0.8,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "30%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          width: "5%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {` : `}
      </Box>
      <Box
        component="span"
        sx={{
          width: "65%",
          pr: 1,
        }}
      >
        {value}
      </Box>
    </Typography>
  );

  if (
    isLoading ||
    categoryLoading ||
    productIsLoading ||
    userIsLoading ||
    productCountIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <Card className={classes.stepperCard} sx={{ height: "100%" }}>
          <Grid container spacing={2} p={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"center"}
                spacing={2}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  display={isMobileRes ? "flex" : undefined}
                  alignContent={"center"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box className={classes.productBox}>
                    <img
                      src={ReplaceImage}
                      alt="img"
                      className={classes.SelectImageTable}
                    />
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="h4" textAlign={"center"}>
                    {toProperCase(product?.storeName)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ px: 2, pb: 3 }}
                className={classes.titleGrid}
              >
                <Grid item xs={12}>
                  <Stack spacing={2}>
                    {/* {product?.isActive && ( */}
                    <DetailRow
                      label="Active"
                      value={product?.isActive ? "Yes" : "No"}
                    />
                    {/* )} */}

                    {product?.storeDescription && (
                      <DetailRow
                        label="Short Description"
                        value={product.storeDescription}
                      />
                    )}

                    {product?.selectCategories &&
                      product?.selectCategories?.length > 0 && (
                        <DetailRow
                          label="Category"
                          value={product.selectCategories
                            .map((id) => categoryMap.get(id) || "")
                            .join(", ")}
                        />
                      )}

                    {product?.created_by && (
                      <DetailRow
                        label="Created by"
                        value={userMap.get(product.created_by)}
                      />
                    )}

                    {product?.created_at && (
                      <DetailRow
                        label="Created at"
                        value={dayjs(product.created_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}

                    {product?.updated_by && (
                      <DetailRow
                        label="Updated by"
                        value={userMap.get(product.updated_by)}
                      />
                    )}

                    {product?.updated_by && product?.updated_at && (
                      <DetailRow
                        label="Updated at"
                        value={dayjs(product.updated_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {product && (
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.editButtonList}
                          onClick={handleOpenEditTenant}
                        >
                          <EditSharpIcon className={classes.editListIcon} />
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.deleteButtonList}
                          // onClick={() => handleOpenDeletePopupMI(product)}
                        >
                          <DeleteOutlineSharpIcon
                            className={classes.deleteListIcon}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <Grid container spacing={4} p={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Active"
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCardIcon
                  label={`Product (${countVariant.length || 0})`}
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={12} xs={12}></Grid>
              <Grid item lg={3} md={6} sm={12} xs={12}></Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={1}
                sx={{
                  // borderBottom: 2,
                  padding: 2,
                }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Typography
                    gutterBottom
                    className={classes.variantViewHedingeProg}
                  >
                    Variant
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  lg={8}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CiSearch className={classes.searchWidgetIcon} />
                            </InputAdornment>
                          ),
                          classes: {
                            root: classes.formControlList,
                          },
                        }}
                        fullWidth
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Name & Display Name.."
                        className={classes.searchTextField}
                        size="small"
                      />
                    </Grid>
                    {/* <Grid item>
                      <Button
                        // variant="contained"
                        className={classes.addNewButton}
                        onClick={handleAddProductClick}
                      >
                        Add Variant
                      </Button>
                    </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid>
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow sx={{ minWidth: "800px" }}>
                        <TableCell
                          className={classes.tablheaderNoWidth}
                          sx={{ width: "5%" }}
                        >
                          <strong>#</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          sx={{ width: "60%" }}
                        >
                          <strong>Item</strong>
                        </TableCell>
                        {!isMobileRes && (
                          <TableCell
                            className={classes.tablheader}
                            sx={{ width: "60%" }}
                          >
                            <strong>Ref No</strong>
                          </TableCell>
                        )}
                        <TableCell
                          className={classes.tablheader}
                          sx={{ width: "60%" }}
                        >
                          <strong>Price</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Actions</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {productIsError || countVariant.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            {productIsError
                              ? "Error fetching data"
                              : "No data available"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        countVariant
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: IVariantViewUp, index) => (
                            <TableRow
                              key={row.id}
                              className={classes.tableRowHover}
                            >
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                {index + 1}
                              </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                <Link
                                  to={`/variant/view/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{ cursor: "pointer" }}
                                    alignItems="center"
                                    onClick={() =>
                                      navigate(`/variant/view/${row.id}`)
                                    }
                                  >
                                    <Grid item xs="auto">
                                      <Box
                                        className={
                                          classes.SelectImageTableBoxwithBorder
                                        }
                                      >
                                        {row.variantImg || ReplaceImage ? (
                                          <img
                                            src={row.variantImg || ReplaceImage}
                                            alt="img"
                                            className={classes.SelectImageTable}
                                            onError={(e) =>
                                              (e.currentTarget.src =
                                                ReplaceImage)
                                            }
                                          />
                                        ) : (
                                          <IoIosImages
                                            className={classes.SelectImageTable}
                                          />
                                        )}
                                      </Box>
                                    </Grid>
                                    <Grid item xs>
                                      <Typography
                                        className={classes.nameTableList}
                                      >
                                        {toProperCase(row?.variantName)}
                                      </Typography>
                                      {isMobileRes &&
                                        row.storeDetails &&
                                        row.storeDetails.referenceNo && (
                                          <>
                                            <Typography
                                              className={classes.mobileListText}
                                            >
                                              {`Ref No : ${row.storeDetails.referenceNo}`}
                                            </Typography>
                                          </>
                                        )}
                                    </Grid>
                                  </Grid>
                                </Link>
                              </TableCell>
                              {!isMobileRes && (
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row?.storeDetails?.referenceNo || ""}
                                </TableCell>
                              )}
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {row?.storeDetails?.price
                                  ? `$${row.storeDetails.price}`
                                  : ""}
                              </TableCell>

                              <TableCell className={classes.tablCell}>
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid item>
                                    <Link
                                      to={`/variant/view/${row.id}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        className={classes.viewButtonList}
                                        onClick={() =>
                                          navigate(`/variant/view/${row.id}`)
                                        }
                                      >
                                        <VisibilitySharpIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            </TableRow>
                          ))
                      )}
                    </TableBody>
                  </Table>

                  <Grid
                    spacing={5}
                    p={"18px"}
                    py={4}
                    justifyContent={"end"}
                    container
                    textAlign={"center"}
                    alignContent={"center"}
                    alignItems={"center"}
                  >
                    <Grid
                      sx={{
                        textAlign: "end",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Pagination
                        count={coursings.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                      />
                    </Grid>
                  </Grid>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      {selectCustomer && product && (
        <NewPopupTenant
          openModel={openDialog}
          handleCloseDialog={handleCloseEditTenant}
          data={product}
        />
      )}
      {productToDeleteMI && (
        <DeletePopup
          open={openDeleteProductMI}
          handleCloseDelete={handleCloseDeletePopupMI}
          onConfirm={async () => {
            await handleDeleteMI(productToDeleteMI.id.toString());
          }}
          title="Delete Supplier"
          content={`Are you sure you want to delete "${productToDeleteMI.storeName}"?`}
        />
      )}

      <AlertPopUp
        open={deleteAlert}
        onCloseAlert={setDeleteAlert}
        message={alertMessage}
      />
    </Grid>
  );
};

export default Index;
